import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getEventBySlug } from "../../API/Events/eventService";
import { CalendarClock } from "lucide-react";
import background from "../../images/Hydreaulys.jpg"
const EventSinglePage = () => {
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

  const { id } = useParams();
  const [eventData, setEventData] = useState<any>();
  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        const eventData = await getEventBySlug(id);
        setEventData(eventData);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  return (
    <div className="mt-10 ">
      {" "}
      <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
        <div className="inline-block rounded-sm bg-primary">
          {" "}
          <p className="p-2 font-bold text-white">
            # {(eventData && eventData?.tag) || "Aqua"}
          </p>
        </div>
        <div className="mt-5">
          <h1 className="text-2xl font-bold text-black">
            {(eventData && eventData?.title) || "Titre"}
          </h1>

          <div className="flex mt-2 space-x-3">
            <div>
              <CalendarClock className="text-primary" />
            </div>
            <div className="text-black ">
              {(eventData &&
                new Date(eventData?.createdAt).toLocaleDateString("fr-FR", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                })) ||
                new Date().toLocaleDateString("fr-FR")}
            </div>
          </div>
          <hr className="w-full h-1 mt-5 bg-primary" />
        </div>

        <div className="mt-5">
          <img src={eventData?.image ? `${uploadUrl}/events/${eventData?.image}` : background} alt="" />
        </div>

        <div className="mt-10">
          {(eventData && eventData.description && (
            <p dangerouslySetInnerHTML={{ __html: eventData.description }} />
          )) ||
            "Contrairement à une opinion répandue, le Lorem Ipsum n'est pas simplement du texte aléatoire. Il trouve ses racines dans une oeuvre de la littérature latine classique datant de 45 av. J.-C., le rendant vieux de 2000 ans. Contrairement à une opinion répandue, le Lorem Ipsum n'est pas simplement du texte aléatoire. Il trouve ses racines dans une oeuvre de la littérature latine classique datant de 45 av. J.-C., le rendant vieux de 2000 ans."}
        </div>
      </div>
    </div>
  );
};

export default EventSinglePage;
